// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__16Xgm","paramInput":"JobSimulator_paramInput__2TZpV","input":"JobSimulator_input__1BZ7C"};